import { cx } from '@emotion/css'
import { VideoDetails } from '@news-mono/web-common'
import React from 'react'

export interface VideoMetadataProps {
    className?: string
    type: VideoDetails['videoType']
    duration?: string
    source?: string
}

export const VideoMetadata: React.FC<VideoMetadataProps> = ({
    className,
    duration,
    source,
    type,
}) => {
    if (!duration && !source) {
        return null
    }

    const shouldDisplayLive = type === 'live'
    const shouldDisplayDuration = !shouldDisplayLive && duration
    const shouldDisplaySource = source !== undefined
    const shouldDisplayDivider =
        (shouldDisplayDuration || shouldDisplayLive) && shouldDisplaySource

    return (
        <p className={cx(className, 'video-metadata')}>
            {shouldDisplayLive && 'Live'}
            {shouldDisplayDuration && <time>{duration}</time>}
            {shouldDisplayDivider && ' | '}
            {shouldDisplaySource && <span>{source}</span>}
        </p>
    )
}
VideoMetadata.displayName = 'VideoMetadata'
